(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-video-wrapper]').forEach((wrapper) => {
    const video = wrapper.querySelector('video');
    const playButton = wrapper.querySelector('[data-play-button]');

    if (!video || !playButton) return;

    // Initially, if video is not playing, show button.
    // However, if autoplay is off, we are showing poster + button.

    // Play button click
    playButton.addEventListener('click', (e) => {
      e.stopPropagation(); // Prevent bubbling to wrapper click if any
      e.preventDefault();
      video.play();
      playButton.classList.add('hero__play-button--hidden');
    });

    // Video click to pause
    video.addEventListener('click', (e) => {
      e.stopPropagation();
      e.preventDefault();
      if (!video.paused) {
        video.pause();
        playButton.classList.remove('hero__play-button--hidden');
      } else {
        video.play();
        playButton.classList.add('hero__play-button--hidden');
      }
    });

    // Ensure button state syncs if video ends or pauses by other means
    video.addEventListener('pause', () => {
      playButton.classList.remove('hero__play-button--hidden');
    });

    video.addEventListener('play', () => {
      playButton.classList.add('hero__play-button--hidden');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
